import React, {useMemo} from "react";
import {Collapse} from "reactstrap";
import UserHomepageControlPanelComponents from "../components";
import UserHomepageControlPanelTabCard from "./card";
import classnames from "classnames";

export const UserHomepageControlPanelTab = ({tab, sortable, onlyRenderComponents, dragging}) => {

    const components = useMemo(() => (
        <Collapse isOpen={tab.expanded}>
            <div>
                {
                    tab.expanded &&
                    <UserHomepageControlPanelComponents
                        tab={tab}
                        dragging={dragging}
                    />
                }
            </div>
        </Collapse>
    ), [tab.id, tab.components, tab.expanded, dragging])

    return (
        <>
            <div
                id={tab?.controlPanelElementId}
                className={classnames(
                    'user-homepage-control-panel-tab',
                    {
                        'only-components': onlyRenderComponents,
                    })
                }
            >
                {
                    !onlyRenderComponents &&
                    <UserHomepageControlPanelTabCard
                        tab={tab}
                        sortable={sortable}
                        dragging={dragging}
                    />
                }
                {components}
            </div>
        </>
    );
}


export default UserHomepageControlPanelTab;
